<nz-card>
  <h1>{{ 'ADMIN.SUPPORT_CENTER.TITLE' | translate }}</h1>

  <nz-tabset [(nzSelectedIndex)]="activeTab">
    <nz-tab [nzTitle]="'ADMIN.SUPPORT_CENTER.TABS.SUPPORT_REQUESTS' | translate">
      <div class="admin-support-toolbar">
        <input nz-input [(ngModel)]="supportSearch" [placeholder]="'ADMIN.SUPPORT_CENTER.SEARCH_SUPPORT' | translate" />
        <nz-select [(ngModel)]="supportTypeFilter" (ngModelChange)="loadSupportRequests()" [nzPlaceHolder]="'ADMIN.SUPPORT_CENTER.FILTER_TYPE' | translate">
          <nz-option nzValue="" [nzLabel]="'ADMIN.SUPPORT_CENTER.FILTER_ALL' | translate"></nz-option>
          <nz-option nzValue="support" [nzLabel]="'ADMIN.SUPPORT_CENTER.TYPE_SUPPORT' | translate"></nz-option>
          <nz-option nzValue="bug" [nzLabel]="'ADMIN.SUPPORT_CENTER.TYPE_BUG' | translate"></nz-option>
          <nz-option nzValue="feature" [nzLabel]="'ADMIN.SUPPORT_CENTER.TYPE_FEATURE' | translate"></nz-option>
        </nz-select>
        <nz-select [(ngModel)]="supportStatusFilter" (ngModelChange)="loadSupportRequests()" [nzPlaceHolder]="'ADMIN.SUPPORT_CENTER.FILTER_STATUS' | translate">
          <nz-option nzValue="" [nzLabel]="'ADMIN.SUPPORT_CENTER.FILTER_ALL' | translate"></nz-option>
          <nz-option *ngFor="let status of supportStatuses" [nzValue]="status" [nzLabel]="'ADMIN.SUPPORT_CENTER.STATUS.' + status | translate"></nz-option>
        </nz-select>
      </div>

      <nz-table [nzData]="filteredSupportRequests" [nzLoading]="loadingSupport" [nzPageSize]="10">
        <thead>
          <tr>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.TYPE' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.SUBJECT' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.STATUS' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.PRIORITY' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.USER' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.COMPANY' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.CONTEXT' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.CREATED' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredSupportRequests">
            <td>{{ ('ADMIN.SUPPORT_CENTER.TYPE_' + (item.type || '').toUpperCase()) | translate }}</td>
            <td>{{ item.subject }}</td>
            <td>
              <nz-select [ngModel]="item.status" (ngModelChange)="updateStatus(item._id, $event)">
                <nz-option *ngFor="let status of supportStatuses" [nzValue]="status" [nzLabel]="'ADMIN.SUPPORT_CENTER.STATUS.' + status | translate"></nz-option>
              </nz-select>
            </td>
            <td>{{ item.priority }}</td>
            <td>{{ item.context?.user?.name || '—' }}<br /><small>{{ item.context?.user?.email || '—' }}</small></td>
            <td>{{ item.context?.user?.companyId || '—' }}</td>
            <td>{{ item.context?.route || '—' }}<br /><small>{{ item.context?.pageTitle || '—' }}</small></td>
            <td>{{ item.createdAt | date: 'short' }}</td>
            <td><button nz-button nzType="default" (click)="openSupportDetails(item._id)">{{ 'ADMIN.SUPPORT_CENTER.VIEW_DETAILS' | translate }}</button></td>
          </tr>
        </tbody>
      </nz-table>
    </nz-tab>

    <nz-tab [nzTitle]="'ADMIN.SUPPORT_CENTER.TABS.AI_INTERACTIONS' | translate">
      <div class="admin-support-toolbar">
        <input nz-input [(ngModel)]="aiSearch" [placeholder]="'ADMIN.SUPPORT_CENTER.SEARCH_AI' | translate" />
        <nz-select [(ngModel)]="aiFeedbackFilter" (ngModelChange)="loadAiInteractions()" [nzPlaceHolder]="'ADMIN.SUPPORT_CENTER.FILTER_FEEDBACK' | translate">
          <nz-option nzValue="" [nzLabel]="'ADMIN.SUPPORT_CENTER.FILTER_ALL' | translate"></nz-option>
          <nz-option nzValue="up" [nzLabel]="'ADMIN.SUPPORT_CENTER.FEEDBACK_UP' | translate"></nz-option>
          <nz-option nzValue="down" [nzLabel]="'ADMIN.SUPPORT_CENTER.FEEDBACK_DOWN' | translate"></nz-option>
          <nz-option nzValue="none" [nzLabel]="'ADMIN.SUPPORT_CENTER.FEEDBACK_NONE' | translate"></nz-option>
        </nz-select>
      </div>

      <nz-table [nzData]="filteredAiInteractions" [nzLoading]="loadingAi" [nzPageSize]="10">
        <thead>
          <tr>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.QUESTION' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.ANSWER_PREVIEW' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.LANGUAGE' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.FEEDBACK' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.CONFIDENCE' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.SOURCES' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.CONTEXT' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.CREATED' | translate }}</th>
            <th>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredAiInteractions">
            <td>{{ item.question }}</td>
            <td>{{ getAnswerPreview(item.answer) }}</td>
            <td>{{ item.language || '—' }}</td>
            <td>{{ item.feedback || '—' }}</td>
            <td>{{ item.confidence != null ? (item.confidence | number : '1.2-2') : '—' }}</td>
            <td>{{ getSourceCount(item) }}</td>
            <td>{{ item.context?.route || '—' }}<br /><small>{{ item.context?.user?.email || '—' }}</small></td>
            <td>{{ item.createdAt | date: 'short' }}</td>
            <td><button nz-button nzType="default" (click)="openAiDetails(item._id)">{{ 'ADMIN.SUPPORT_CENTER.VIEW_DETAILS' | translate }}</button></td>
          </tr>
        </tbody>
      </nz-table>
    </nz-tab>
  </nz-tabset>
</nz-card>

<nz-modal
  [nzVisible]="detailVisible"
  [nzFooter]="null"
  [nzWidth]="840"
  [nzTitle]="detailType === 'support' ? ('ADMIN.SUPPORT_CENTER.DETAIL_SUPPORT' | translate) : ('ADMIN.SUPPORT_CENTER.DETAIL_AI' | translate)"
  (nzOnCancel)="closeDetails()"
>
  <ng-container *nzModalContent>
    <div class="admin-support-detail" *ngIf="selectedItem">
      <div class="admin-support-detail__block">
        <h3>{{ 'ADMIN.SUPPORT_CENTER.DETAILS' | translate }}</h3>
        <p><strong>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.SUBJECT' | translate }}:</strong> {{ selectedItem.subject || '—' }}</p>
        <p *ngIf="detailType === 'support'"><strong>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.STATUS' | translate }}:</strong> {{ selectedItem.status }}</p>
        <p *ngIf="detailType === 'support'"><strong>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.PRIORITY' | translate }}:</strong> {{ selectedItem.priority }}</p>
        <p *ngIf="detailType === 'support'"><strong>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.TYPE' | translate }}:</strong> {{ selectedItem.type }}</p>
        <p *ngIf="detailType === 'ai'"><strong>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.LANGUAGE' | translate }}:</strong> {{ selectedItem.language || '—' }}</p>
        <p *ngIf="detailType === 'ai'"><strong>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.FEEDBACK' | translate }}:</strong> {{ selectedItem.feedback || '—' }}</p>
        <p *ngIf="detailType === 'ai'"><strong>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.CONFIDENCE' | translate }}:</strong> {{ selectedItem.confidence != null ? (selectedItem.confidence | number : '1.2-2') : '—' }}</p>
        <p><strong>{{ 'ADMIN.SUPPORT_CENTER.COLUMNS.CREATED' | translate }}:</strong> {{ selectedItem.createdAt | date: 'medium' }}</p>
        <p *ngIf="selectedItem.updatedAt"><strong>{{ 'ADMIN.SUPPORT_CENTER.UPDATED_AT' | translate }}:</strong> {{ selectedItem.updatedAt | date: 'medium' }}</p>
      </div>

      <div class="admin-support-detail__block" *ngIf="detailType === 'support'">
        <h3>{{ 'ADMIN.SUPPORT_CENTER.MESSAGE_SECTION' | translate }}</h3>
        <pre>{{ selectedItem.message || '—' }}</pre>
        <pre *ngIf="selectedItem.bugDetails?.whatHappened || selectedItem.bugDetails?.expectedBehavior || selectedItem.bugDetails?.stepsToReproduce?.length">{{ selectedItem.bugDetails | json }}</pre>
        <pre *ngIf="selectedItem.featureDetails?.tryingToDo || selectedItem.featureDetails?.missingFeature || selectedItem.featureDetails?.impact">{{ selectedItem.featureDetails | json }}</pre>
      </div>

      <div class="admin-support-detail__block" *ngIf="detailType === 'ai'">
        <h3>{{ 'ADMIN.SUPPORT_CENTER.AI_SECTION' | translate }}</h3>
        <pre>{{ selectedItem.question || '—' }}</pre>
        <pre>{{ selectedItem.answer || '—' }}</pre>
        <pre>{{ selectedItem.sources || [] | json }}</pre>
      </div>

      <div class="admin-support-detail__block">
        <h3>{{ 'ADMIN.SUPPORT_CENTER.CONTEXT_SECTION' | translate }}</h3>
        <pre>{{ selectedItem.context || {} | json }}</pre>
      </div>

      <div class="admin-support-detail__block" *ngIf="detailType === 'support' && selectedItem.aiContext">
        <h3>{{ 'ADMIN.SUPPORT_CENTER.AI_CONTEXT_SECTION' | translate }}</h3>
        <pre>{{ selectedItem.aiContext | json }}</pre>
      </div>
    </div>
  </ng-container>
</nz-modal>
